import { render, staticRenderFns } from "./Ncm.vue?vue&type=template&id=278f50c8"
import script from "./Ncm.vue?vue&type=script&lang=js"
export * from "./Ncm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports